(function () {
  function getCartDrawer() {
    return document.querySelector('cart-drawer');
  }

  function getCartDrawerItems() {
    return document.querySelector('cart-drawer-items');
  }

  function afterDrawerDomUpdate(drawer) {
    if (!drawer) return;
    drawer.classList.remove('is-empty');
    const overlay = drawer.querySelector('#CartDrawer-Overlay');
    overlay?.addEventListener('click', drawer.close.bind(drawer));
    drawer.bindPremiumDrawerUi?.();
    drawer.setHeaderCartIconAccessibility?.();
    bind(document);
  }

  function applyDrawerSectionsFast(sections) {
    if (!sections) return false;

    const drawer = getCartDrawer();
    const itemsEl = getCartDrawerItems();
    const drawerHtml = sections['cart-drawer'] || sections.cart_drawer;
    let applied = false;

    if (drawerHtml && typeof itemsEl?.applyDrawerSectionHtml === 'function') {
      itemsEl.applyDrawerSectionHtml(drawerHtml);
      applied = true;
    } else if (drawerHtml && drawer?.getSectionInnerHTML) {
      const sectionElement = document.querySelector('#CartDrawer');
      if (sectionElement) {
        sectionElement.innerHTML = drawer.getSectionInnerHTML(drawerHtml, '#CartDrawer');
        applied = true;
      }
    }

    const iconHtml = sections['cart-icon-bubble'];
    if (iconHtml && drawer?.getSectionInnerHTML) {
      const iconEl = document.getElementById('cart-icon-bubble');
      if (iconEl) {
        iconEl.innerHTML = drawer.getSectionInnerHTML(iconHtml);
        applied = true;
      }
    }

    if (applied) afterDrawerDomUpdate(drawer);
    return applied;
  }

  function refreshDrawerSections() {
    return fetch(`${window.location.pathname}?sections=${encodeURIComponent('cart-drawer,cart-icon-bubble')}`)
      .then((r) => r.json())
      .then((sections) => applyDrawerSectionsFast(sections))
      .catch(() => false);
  }

  function setButtonState(button, { loading, label }) {
    if (!button) return;
    button.disabled = !!loading;
    button.classList.toggle('is-loading', !!loading);
    if (label != null) button.textContent = label;
  }

  function addVariant(variantId, button) {
    if (!variantId || button?.disabled) return;

    const originalLabel = button.textContent;
    setButtonState(button, { loading: true, label: 'Adding…' });

    const sectionIds = 'cart-drawer,cart-icon-bubble';

    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({
        items: [
          {
            id: parseInt(variantId, 10),
            quantity: 1,
            properties: { _add_source: 'Cart drawer — You may also like' },
          },
        ],
        sections: sectionIds,
        sections_url: window.location.pathname,
      }),
    })
      .then((r) => r.json())
      .then((response) => {
        if (response.status) {
          setButtonState(button, { loading: false, label: originalLabel });
          return;
        }

        const painted = response.sections ? applyDrawerSectionsFast(response.sections) : false;
        if (!painted) {
          refreshDrawerSections().finally(() => {
            setButtonState(button, { loading: false, label: originalLabel });
          });
        } else {
          /* Button node may be gone after DOM patch — only reset if still in document */
          if (button.isConnected) {
            setButtonState(button, { loading: false, label: originalLabel });
          }
        }

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-drawer-ymal', cartData: response });
        }
      })
      .catch(() => {
        setButtonState(button, { loading: false, label: originalLabel });
      });
  }

  function bind(scope) {
    (scope || document).querySelectorAll('[data-cart-drawer-ymal-atc]').forEach((btn) => {
      if (btn.dataset.bound === 'true') return;
      btn.dataset.bound = 'true';
      btn.addEventListener('click', (event) => {
        event.preventDefault();
        addVariant(btn.dataset.variantId, btn);
      });
    });
  }

  function init() {
    bind(document);
    document.addEventListener('cart-drawer:dom-updated', () => bind(document));
    document.addEventListener('click', (event) => {
      const btn = event.target.closest('[data-cart-drawer-ymal-atc]');
      if (!btn) return;
      if (btn.dataset.bound === 'true') return;
      event.preventDefault();
      btn.dataset.bound = 'true';
      addVariant(btn.dataset.variantId, btn);
      bind(btn.closest('[data-cart-drawer-ymal]') || document);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
